import { RESOURCE_MODULE_IDS } from "config/constants";

const ALLOWED_CAMPUS_SPACES = [
    RESOURCE_MODULE_IDS.LIBRARY,
    RESOURCE_MODULE_IDS.UNIVERSITY_SPACES
];
export const onlyAllowedCampusSpaces = id => ALLOWED_CAMPUS_SPACES.includes(id);